import React from "react";
import styled from "styled-components";
import { ProcessorLogo } from "../icons/ProcessorLogo";

type HeaderProps = {
  fontweight?: string;
  margin?: string;
};

const StyledProcessorLogo = styled(ProcessorLogo)`
  width: 35px;
  height: 35px;
`;

export default function Header() {
  return (
    <StyledHeader>
      <StyledLogo href={"#"}>MINES</StyledLogo>

      <StyledNav>
        <ProcessorWrapper>
          <StyledProcessorLogo />
          <StyledLink fontweight={"500"} margin={"0 0 0 8px"}>
            Admin
          </StyledLink>
        </ProcessorWrapper>

        <span>|</span>

        <StyledLink>로그아웃</StyledLink>
      </StyledNav>
    </StyledHeader>
  );
}

const StyledHeader = styled.div`
  width: 100%;
  height: 70px;
  color: #fff;
  background-color: #1565c0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
`;

const StyledLogo = styled.a`
  font-size: 20px;
  color: white;
  text-decoration: none;
  font-weight: 800;
  margin-left: 40px;

  &:hover {
    text-decoration: none;
    color: #e7e5e5;
  }
`;

const StyledNav = styled.div`
  width: 210px;
  height: 20px;
  margin-right: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ProcessorWrapper = styled.div`
  width: 100px;
  height: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledLink = styled.a<HeaderProps>`
  font-size: 14px;
  color: white;
  text-decoration: none;
  font-weight: ${(props) => (props.fontweight ? props.fontweight : "400")};
  margin-left: ${(props) => (props.margin ? props.margin : "0")};
  cursor: pointer;
  &:hover {
    text-decoration: none;
    color: #f3f3f3;
  }
`;
